/* ==========================================================================
   MARELLE — galerie filtrée par coloris (D1)

   Speedfly affiche tous les visuels du produit dans la galerie ; au
   changement de coloris, seule l'image principale change. Ce script ne
   garde que les visuels du coloris choisi.

   Rattachement visuel → coloris : par le NOM DE FICHIER. Chaque coloris
   donne une clé (premier mot du nom, sans accent : Noir → « noir »,
   Crème → « creme », Rose poudré → « rose ») ; un visuel appartient au
   coloris dont la clé apparaît le plus tôt dans son nom de fichier
   (« marelle-bottes-pluie-femme-taupe-fauteuil-rose.png » → taupe).
   Un visuel sans clé reste visible pour tous les coloris.
   → Convention à respecter pour tout nouveau visuel.

   Aucun fichier Speedfly n'est modifié, aucune réinitialisation de la
   galerie n'est forcée : les visuels des autres coloris sont retirés du
   DOM puis réinsérés au changement. La position des visuels restants est
   recalculée (premier visuel pleine largeur en grille desktop), et un
   compteur « 1 / n » propre remplace celui de Speedfly sur mobile.

   Sans JavaScript : tous les visuels restent visibles.
   ========================================================================== */
(function () {
  'use strict';

  var GARDE = '__marelleColoris';

  function cle(texte) {
    var t = String(texte || '');
    if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    var mots = t.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
    return mots[0] || '';
  }

  function nomFichier(src) {
    var nom = String(src || '').split('?')[0].split('/').pop();
    try { nom = decodeURIComponent(nom); } catch (e) {}
    return nom.toLowerCase();
  }

  function cleDuFichier(fichier, cles) {
    var meilleure = '';
    var position = Infinity;
    for (var i = 0; i < cles.length; i++) {
      var p = fichier.indexOf(cles[i]);
      if (p !== -1 && p < position) { position = p; meilleure = cles[i]; }
    }
    return meilleure;
  }

  function installer(galerie) {
    if (!galerie || galerie[GARDE]) return;

    var rail = galerie.querySelector('[data-pm-main]');
    var section = galerie.closest('section') || document;
    var fieldset = section.querySelector('.pvp-option--mode-swatch');
    if (!rail || !fieldset) return;

    var position = parseInt(fieldset.getAttribute('data-option-position'), 10);
    if (isNaN(position)) return;

    var entrees = [].slice.call(fieldset.querySelectorAll('input[data-pvp-value]'));
    var cles = entrees.map(function (e) { return cle(e.value); }).filter(Boolean);
    if (cles.length < 2) return;

    var visuels = [].slice.call(rail.querySelectorAll('.pm-gallery__slide'));
    if (visuels.length < 2) return;

    var bandeau = galerie.querySelector('[data-pm-thumbs]');
    var vignettes = bandeau ? [].slice.call(bandeau.querySelectorAll('.pm-gallery__thumb')) : [];
    var pointsWrap = galerie.querySelector('[data-pm-dots]');
    var points = pointsWrap ? [].slice.call(pointsWrap.querySelectorAll('[data-pm-dot]')) : [];

    var cleParMedia = {};
    var auMoinsUne = false;
    visuels.forEach(function (v) {
      var img = v.querySelector('img');
      var video = v.querySelector('video');
      var src = img ? img.getAttribute('src') : (video ? video.getAttribute('poster') : '');
      var k = cleDuFichier(nomFichier(src), cles);
      if (k) auMoinsUne = true;
      cleParMedia[v.getAttribute('data-media-id')] = k;
    });
    if (!auMoinsUne) return;

    galerie[GARDE] = true;
    galerie.classList.add('m-galerie-coloris');

    var compteur = document.createElement('div');
    compteur.className = 'm-compteur';
    compteur.setAttribute('aria-hidden', 'true');
    galerie.appendChild(compteur);

    var courant = null;
    var nombre = visuels.length;

    function garder(el, k) {
      var c = cleParMedia[el.getAttribute('data-media-id')];
      return !c || c === k;
    }

    function majCompteur() {
      var largeur = rail.clientWidth || 1;
      var i = Math.round(rail.scrollLeft / largeur);
      if (i < 0) i = 0;
      if (i > nombre - 1) i = nombre - 1;
      compteur.textContent = (i + 1) + ' / ' + nombre;
      compteur.hidden = nombre < 2;
    }

    function appliquer(k) {
      if (k === courant) return;
      var gardes = visuels.filter(function (v) { return garder(v, k); });
      if (gardes.length === 0) gardes = visuels.slice();
      nombre = gardes.length;

      visuels.forEach(function (v) { if (v.parentNode) v.parentNode.removeChild(v); });
      gardes.forEach(function (v, i) {
        v.classList.toggle('pm-gallery__slide--first', i === 0);
        if (i === 0) v.setAttribute('data-first-image', '');
        else v.removeAttribute('data-first-image');
        var pos = 'pair';
        if (i === 0) pos = 'first';
        else if (i === nombre - 1 && nombre % 2 === 0) pos = 'last-odd';
        v.setAttribute('data-position', pos);
        var img = v.querySelector('img');
        if (img && i < 2) img.setAttribute('loading', 'eager');
        rail.appendChild(v);
      });

      var ids = gardes.map(function (v) { return v.getAttribute('data-media-id'); });
      if (bandeau) {
        vignettes.forEach(function (t) { if (t.parentNode) t.parentNode.removeChild(t); });
        ids.forEach(function (id) {
          for (var j = 0; j < vignettes.length; j++) {
            if (vignettes[j].getAttribute('data-media-id') === id) { bandeau.appendChild(vignettes[j]); break; }
          }
        });
      }
      if (pointsWrap) {
        points.forEach(function (p, i) {
          if (i < nombre) {
            p.setAttribute('data-pm-dot', String(i));
            p.classList.toggle('pm-gallery__dot--active', i === 0);
            pointsWrap.appendChild(p);
          } else if (p.parentNode) {
            p.parentNode.removeChild(p);
          }
        });
      }

      rail.scrollLeft = 0;
      courant = k;
      majCompteur();
    }

    function coloriSelectionne() {
      var coche = fieldset.querySelector('input[data-pvp-value]:checked');
      return coche ? cle(coche.value) : cles[0];
    }

    var tick = false;
    rail.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(function () { tick = false; majCompteur(); });
    }, { passive: true });

    document.addEventListener('product:variant-changed', function (e) {
      var variante = e.detail && e.detail.variant;
      if (!variante || !variante.options) return;
      appliquer(cle(variante.options[position - 1]));
    });

    appliquer(coloriSelectionne());
  }

  function tout() {
    [].slice.call(document.querySelectorAll('[data-pm-gallery]')).forEach(installer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();

  document.addEventListener('shopify:section:load', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-pm-gallery]')).forEach(installer);
  });
})();
